import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  coursechapterColumns,
  coursechapterRows,
  fetchCoursechapterRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";
const CoursechapterDataTable = () => {
  const [data, setData] = useState(coursechapterRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchCoursechapterRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);
  const handleSaveID = (id) => {
    // Make a DELETE request to the Flask API endpoint
    localStorage.setItem("chapter_id_for_unit", id);
  };
  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_cchapter/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete teacher");
        }
        setData(data.filter((item) => item.id !== id));
        toast.success("Course Chapter deleted successfully!");
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };
  const listingLinkString = "Unit-Listing";
  const viewLinkString = "Coursechapter-Single";
  const editLinkString = "Coursechapter-Edit";
  const newLinkString = "Coursechapter-New";
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 300,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(listingLinkString) && (
              <Link
                to={`/teacher/course-chapter/unit`}
                style={{ textDecoration: "none" }}
              >
                <div
                  className="otherButton"
                  onClick={() => handleSaveID(params.row.id)}
                >
                  Units
                </div>
              </Link>
            )}
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/teacher/course-chapter/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/teacher/course-chapter/update-course-chapter/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle flex justify-between flex-wrap w-full lg:no-flexwrap gap-2  pb-5 lg:pb-10">
        <span>Course Chapters</span>
        <div className="linkGroup flex justify-end w-full gap-2 lg:w-fit items-center lg:gap-2 flex-wrap lg:no-flexwrap">
          {slugs && slugs.includes(newLinkString) && (
            <Link
              to="/teacher/course-chapter/new"
              className="commonButton w-full sm:w-auto"
            >
              Add New
            </Link>
          )}
          <Link to="/teacher" className="commonButton w-full sm:w-auto">
            Back
          </Link>
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={coursechapterColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
        />
      )}{" "}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default CoursechapterDataTable;
